import React from "react";

const MuseumofMystiqueBreadcrumb = () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "https://schema.org/",
                        "@type": "BreadcrumbList",
                        "itemListElement": [{
                            "@type": "ListItem", "position": 1, "name": "Museum of Mystique",
                            "item": "https://www.adventureresortkufri.com/museum-of-mystique"
                        },
                        { "@type": "ListItem", "position": 2, "name": "", "item": "" }]
                    }
                )
            }}
        />
    </React.Fragment>
);
export default MuseumofMystiqueBreadcrumb;